<template>
  <div class="content">
    <div class="thehome">
      <span @click="topathe('/')">{{ $t("header.home") }} </span>&nbsp;/
    </div>
    <div class="activitylist">
      <!-- <div class="t1">
        <div class="atitle animate__animated animate__backInUp">
          {{ $t("header.Upcoming_events") }}：
        </div>
        <div class="alist animate__animated animate__backInUp">
          <div
            class="typealist"
            v-for="(item, index) in state.formationlist"
            :key="index"
            @click="topath(item.id, index)"
            :class="state.flist[index] && 'click'"
          >
            <div>
              {{ (locale == "zh" && item.title) || item.en_title }}
            </div>
          </div>
        </div>
      </div> -->
      <div class="t2" style="margin-top: 40px">
        <div class="atitle animate__animated animate__backInUp">
          {{ $t("header.Latest_activity") }}：
        </div>
        <div class="alist animate__animated animate__backInUp">
          <!-- {{  displayedList}} -->
          <div
            class="typealist"
            v-for="(item, index) in displayedList"
            :key="index"
            @click="topath(item.id, index)"
            :class="[
              (!route.query.id && index === 0) ||
              (route.query.id && item.id == route.query.id)
                ? 'click'
                : '',
            ]"
          >
            <!-- {{ item.id }} -->
            <div>
              {{
                (locale == "zh" && item.title) || item.en_title || item.title
              }}
            </div>
          </div>
          <div class="switch">
            <div>
              <img
                src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241213/icon_left_disabled.svg"
                alt=""
                v-if="isFirstPage"
                style="cursor: no-drop"
              />
              <img
                src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241212/icon_left_selected.svg"
                alt=""
                v-else
                style="cursor: pointer"
                @click="prevPage"
              />
            </div>
            <div style="margin-left: 10px">
              <img
                src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241213/icon_right_disabled.svg"
                alt=""
                v-if="isLastPage"
                style="cursor: no-drop"
              />
              <img
                src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241212/icon_right_selected.svg"
                alt=""
                v-else
                style="cursor: pointer"
                @click="nextPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!state.activitydetail.rich_content">
      <div class="activedetail">
        <div class="atitle animate__animated animate__backInLeft">
          {{
            (locale == "zh" && state.activitydetail.title) ||
            state.activitydetail.en_title ||
            state.activitydetail.title
          }}
        </div>
        <div class="ftitle animate__animated animate__backInLeft">
          {{
            (locale == "zh" && state.activitydetail.intro) ||
            state.activitydetail.en_intro ||
            state.activitydetail.intro
          }}
        </div>
        <div
          class="totheimage animate__animated animate__backInLeft"
          v-if="state.activitydetail.full_image"
        >
          <img :src="state.activitydetail.full_image" alt="" />
        </div>
        <div class="adetail">
          <div
            class="atypedetail animate__animated animate__backInUp"
            v-for="(item, index) in state.activitydetail.details"
            :key="index"
            :style="getdog(index)"
          >
            <div>{{ (locale == "zh" && item.title) || item.en_title }}</div>
            <div>{{ (locale == "zh" && item.content) || item.en_content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="vease" v-html="state.activitydetail.details"></div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch, ref, computed } from "vue";
import { activity } from "@/api/type.js";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
const route = useRoute();
const router = useRouter();
const { locale } = useI18n();
const state = reactive({
  page: 1,
  perPage: 3,
  id: "",
  type: "",
  flist: [],
  flist1: [1],
  formationlist: [
    {
      img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
      title: "自带动画 – 2023年11月，以《大黄蜂》为主角",
      detail:
        "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
      data: "2023.09.13",
      id: 1,
    },
  ],
  formationlist2: [
    {
      img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
      title: "自带动画 – 2023年11月，以《大黄蜂》为主角",
      detail:
        "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
      data: "2023.09.13",
      id: 1,
    },
    {
      img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
      title: "自带动画 – 2023年11月，以《大黄蜂》为主角",
      detail:
        "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
      data: "2023.09.13",
      id: 1,
    },
    {
      img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
      title: "自带动画 – 2023年11月，以《大黄蜂》为主角",
      detail:
        "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
      data: "2023.09.13",
      id: 1,
    },
  ],
  activitydetail: [],
  typedetail: [
    { title: "活动", detail: "数字经济峰会" },
    { title: "主题", detail: "韧性崛起 — 共创智慧未来" },
    { title: "日期", detail: "2023年9月22日" },
    { title: "地点", detail: "香港会议展览中心" },
    { title: "组织者", detail: "中华人民共和国香港特别行政区政府" },
    { title: "支持机构", detail: "中国互联网发展基金会" },
  ],
});
state.id = route.query.id;
state.type = route.query.type;

const itemsPerPage = 3; // 每页显示的项目数
const currentPage = ref(1); // 当前页码

// 总页数
const totalPages = computed(() => {
  return Math.ceil(state.formationlist2.length / itemsPerPage);
});

// 当前页的数据
const displayedList = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return state.formationlist2.slice(start, end);
});

// 是否是第一页
const isFirstPage = computed(() => currentPage.value === 1);

// 是否是最后一页
const isLastPage = computed(() => currentPage.value === totalPages.value);

// 切换到上一页
const prevPage = () => {
  if (!isFirstPage.value) {
    currentPage.value--;
  }
};

// 切换到下一页
const nextPage = () => {
  if (!isLastPage.value) {
    currentPage.value++;
  }
};

watch(
  () => route.fullPath,
  () => {
    console.log(state.type, 987987, route.query);
    if (route.query?.type == "events") {
      let id = 1;
      state.flist = [];
      state.flist1 = [1];
      route.query.id = 1;
      // state.flist[0] = true;
      activity({
        page: state.page,
        perpage: state.perPage,
        id: id,
      }).then((res) => {
        // state.formationlist = res.upcoming.data;
        // state.formationlist2 = [...state.formationlist, ...res.newest.data];
        state.activitydetail = res.data;
        state.formationlist2 = res.more.data.filter(
          (item) => item.id !== 15 && item.id !== 16
        );
        // console.log(state.formationlist2,4324324)
      });
    } else if (route.query?.type == "activity") {
      let id = 3;
      state.flist1 = [];
      (state.flist = []), (state.flist1[0] = true);
      activity({
        page: state.page,
        perpage: state.perPage,
        id: id,
      }).then((res) => {
        // state.formationlist = res.upcoming.data;
        // state.formationlist2 = res.newest.data;
        state.activitydetail = res.data;
        state.formationlist2 = res.more.data.filter(
          (item) => item.id !== 15 && item.id !== 16
        );
        // console.log(state.formationlist2,4324324)
      });
    } else {
      // state.flist1 = [];
      // state.flist = [];
      // state.flist1[0] = true;
      activity({
        page: state.page,
        perpage: state.perPage,
        id: route.query.id,
      }).then((res) => {
        // state.formationlist = res.upcoming.data;
        // state.formationlist2 = [...state.formationlist, ...res.newest.data];
        // state.flist1 = [1];
        state.activitydetail = res.data;
        state.formationlist2 = res.more.data.filter(
          (item) => item.id !== 15 && item.id !== 16
        );
        // console.log(state.formationlist2,4324324)
      });
    }
  },
  { immediate: true }
);
// activity({
//   page: state.page,
//   perpage: state.perPage,
//   id: state.id,
// }).then((res) => {
//   state.formationlist = res.upcoming.data;
//   state.formationlist2 = res.newest.data;
//   state.activitydetail = res.data;
//   // console.log(res.data, 987);
// });
const topath = (e, i) => {
  router.push("activity?id=" + e);
  state.flist1 = [];
  state.flist = [];
  if (e > 0) {
    state.flist1[i] = true;
  } else {
    state.flist[i] = true;
  }
  // console.log(e, i);
  // state.flist1 = [];
  // state.flist = [];

  // console.log(state.flist1,state.flist,989);
};
const topathe = (e) => {
  router.push(e);
};
const getdog = (e) => {
  return `--animate-duration: ${1.5 + e * 0.5}s;`;
};
</script>

<style lang="scss" scoped>
.vease {
  text-align: left;
}
.click {
  color: #e6755a !important;
  border-bottom: 1px solid #e6755a !important;
}
@import "@/sass/index.scss";
.content {
  max-width: 1176px;
  margin: 0 auto;
  position: relative;
  .thehome {
    z-index: 0;
    padding: 68px 0 0 0;
    text-align: left;
    margin-bottom: 80px;
  }
  .activedetail {
    max-width: 676px;
    text-align: left;
    .atitle {
      @include fontstyle(#333, 28px, 800, auto);
      margin-bottom: 24px;
    }
    .ftitle {
      --animate-duration: 1.5s;
      @include fontstyle(#333, 16px, 400, auto);
      margin-bottom: 40px;
      white-space: pre-line;
      line-height: 26px;
    }
    .totheimage {
      --animate-duration: 2s;
      margin-bottom: 60px;
    }
    .totheimage {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .adetail {
      margin-bottom: 100px;
      .atypedetail {
        padding: 28px 20px;
        display: flex;
        border-top: 2px solid #666666;
        :nth-child(1) {
          width: 64px;
          @include fontstyle(#333, 16px, 800, auto);
        }
        :nth-child(2) {
          @include fontstyle(#333, 16px, 400, auto);
          margin-left: 154px;
        }
        &:last-child {
          border-bottom: 2px solid #666666;
        }
      }
    }
  }

  .activitylist {
    position: absolute;
    right: 0px;
    top: 28px;

    // background: #3f58de;
    max-width: 400px;
    text-align: left;
    .atitle {
      @include fontstyle(#fff, 14px, 400, auto);
      margin-bottom: 12px;
    }

    .t1 {
      padding: 40px;
      background: #3f58de;
    }

    .t2 {
      background: #3f58de;
      padding: 40px;
    }
    .alist {
      max-width: 320px;
      @include fontstyle(#fff, 18px, 400, auto);
      line-height: 21px;
      .switch {
        display: flex;
        margin: 20px 0 0;
        // align-items: center;
        // justify-content: center;
      }
      .typealist {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 24px 0px;
        border-bottom: 2px solid #fff;
        position: relative;
        :nth-child(1) {
          width: 80%;
        }
        &::after {
          // http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/icon_.svg
          content: url("https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/rightdf.svg");
          display: block;
          position: absolute;
          right: 0px;
          // width: 9px;
          // right: -2px;
          // bottom: 6px;
        }
        // :last-child{
        //   border-bottom: 0px  !important;
        // }
        &:hover {
          color: #f4775e;
          border-bottom: 2px solid #f4775e;
          &::after {
            // http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/icon_.svg
            content: url("http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/icon_.svg");
            display: block;
            position: absolute;
            right: 0px;
            // width: 9px;
            // right: -2px;
            // bottom: 6px;
          }
        }
      }
      // typealist:last-child {
      //   padding-bottom: 0px;
      //   // border-bottom: 0px !important;
      //   &:hover {
      //     color: #f4775e;
      //     border-bottom: 0px solid #f4775e;
      //   }
      // }
      :first-child {
        padding-top: 0px;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    padding: 30px;
    .thehome {
    }
  }
  .activitylist {
    position: initial !important;
    margin-bottom: 40px;
  }
  .atypedetail {
    :nth-child(2) {
      margin-left: 36px !important;
    }
  }
}
</style>
